import { ClientsManagement } from "@/components/ClientsManagement";
import { useNavigate } from "react-router-dom";

export const ClientsPage = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/");
  };

  return <ClientsManagement onBack={handleBack} />;
};

